import { componentQrl, inlinedQrl, _jsxQ, _fnSignal } from "@builder.io/qwik";
const Text = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxQ("div", null, {
    class: "builder-text",
    dangerouslySetInnerHTML: _fnSignal((p0) => {
      var _a;
      return ((_a = p0.text) == null ? void 0 : _a.toString()) || "";
    }, [
      props
    ], 'p0.text?.toString()||""'),
    style: {
      outline: "none"
    }
  }, null, 3, "yO_0");
}, "Text_component_15p0cKUxgIE"));
export {
  Text,
  Text as default
};
